export const columns = [
  {
    title: 'actions',
    dataIndex: 'key',
    scopedSlots: { customRender: 'key' },
    ellipsis: true,
    width: 100,
    fixed: 'left'
  },
  {
    title: 'page_material_warehousing_material_bar',
    dataIndex: 'barCode',
    scopedSlots: { customRender: 'barCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_type',
    dataIndex: 'materialTypeName',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_batch',
    dataIndex: 'batchCode',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'batchCode' }
  },
  {
    title: 'page_material_warehousing_to_check',
    dataIndex: 'isMustCheck',
    ellipsis: true,
    customRender: (item) => {
      return item == 1 ? '是' : '否'
    },
    width: 150
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'materialStandardModel',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_1',
    dataIndex: 'materialStuff',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_unit',
    dataIndex: 'materialUnit',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_totalNum',
    dataIndex: 'totalNum',
    ellipsis: true,
    scopedSlots: { customRender: 'totalNum' },
    width: 150
  },
  {
    title: 'page_material_warehousing_stockInNum',
    dataIndex: 'stockInNum',
    ellipsis: true,
    scopedSlots: { customRender: 'stockInNum' },
    width: 150
  },
  {
    title: 'page_material_warehousing_price',
    dataIndex: 'price',
    ellipsis: true,
    scopedSlots: { customRender: 'price' },
    width: 150
  },
  {
    title: 'page_material_warehousing_remark',
    dataIndex: 'remark',
    ellipsis: true,
    scopedSlots: { customRender: 'remark' },
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'areaId',
    ellipsis: true,
    scopedSlots: { customRender: 'areaId' },
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'locationId',
    ellipsis: true,
    scopedSlots: { customRender: 'locationId' },
    width: 150
  },
  {
    title: 'supplier',
    dataIndex: 'supplierId',
    ellipsis: true,
    scopedSlots: { customRender: 'supplierId' },
    width: 150
  },
  {
    title: 'page_material_warehousing_testResult',
    dataIndex: 'testResult',
    ellipsis: true,
    scopedSlots: { customRender: 'testResult' },
    width: 150
  },
  {
    title: 'page_material_warehousing_fileName',
    dataIndex: 'fileName',
    ellipsis: true,
    scopedSlots: { customRender: 'fileName' },
    width: 150
  }
]
